import { supabase } from "@/integrations/supabase/client";

export type UserTier = 'DIY' | 'Guided' | 'Premium';

export interface TierInfo {
  tier: UserTier;
  label: string;
  color: string;
  helpOptions: string[];
}

const TIER_CONFIG: Record<UserTier, TierInfo> = {
  DIY: {
    tier: 'DIY',
    label: 'DIY Member',
    color: 'hsl(var(--primary))',
    helpOptions: ['ai', 'community', 'support']
  },
  Guided: {
    tier: 'Guided',
    label: 'Guided Member',
    color: 'hsl(var(--accent))',
    helpOptions: ['ai', 'community', 'support', 'schedule', 'priority-support']
  },
  Premium: {
    tier: 'Premium',
    label: 'Premium Member',
    color: 'hsl(var(--secondary))',
    helpOptions: ['ai', 'community', 'support', 'schedule', 'priority-support', 'dedicated']
  }
};

export const getUserTier = async (userId: string): Promise<UserTier> => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('subscription_tier')
      .eq('id', userId)
      .single();

    if (error) throw error;
    return (data?.subscription_tier as UserTier) || 'Premium';
  } catch (error) {
    console.error('Error fetching user tier:', error);
    return 'Premium';
  }
};

export const getTierInfo = (tier: UserTier): TierInfo => {
  return TIER_CONFIG[tier];
};

export const canAccessHelpOption = (option: string, tier: UserTier): boolean => {
  return TIER_CONFIG[tier].helpOptions.includes(option);
};

export const getTierLabel = (tier: UserTier): string => {
  return TIER_CONFIG[tier].label;
};

export const getTierColor = (tier: UserTier): string => {
  return TIER_CONFIG[tier].color;
};